import React from "react"
import { CardProps, Typography } from "antd"

import css from "./index.module.css"

export type WidgetCardProps = {
  children: React.ReactNode
  headerAppend?: React.ReactNode
  style?: React.CSSProperties
  title: string
}
export const WidgetCard = (props: WidgetCardProps) => {
  const { Title } = Typography

  return (
    <div className={css.card} style={{ ...props.style }}>
      <div className={css.cardHeader}>
        <Title className={css.title} level={5}>
          {props.title}
        </Title>

        {props.headerAppend}
      </div>

      <div>{props.children}</div>
    </div>
  )
}
